// extracted by mini-css-extract-plugin
module.exports = {"switchTabN":"SwitchTabN_switchTabN__FNIQe"};